export default function PopularRoute() {
  return (
    <>
      <section className="section" id="routes">
        <div className="container">
          <p className="section-eyebrow">Trending this week</p>
          <h2 className="section-title">Popular routes</h2>
          <p className="section-sub">
            Fixed fares on the routes riders book the most.
          </p>
          <div className="routes-grid" id="routesGrid">
            {/* injected by JS, static fallback below */}
            <div
              className="route-card reveal in"
              data-from="Lucknow"
              data-to="Kanpur"
            >
              <div className="route-top">
                <span className="route-path">Lucknow → Kanpur</span>
                <span className="route-seats">4 cabs · today</span>
              </div>
              <div className="route-meta">
                <span>⏱ 1h 45m</span>
                <span>📏 80 km</span>
              </div>
              <div className="route-bottom">
                <span className="route-price">
                  ₹279 <small>/seat</small>
                </span>
                <button className="btn btn-primary btn-sm route-book">
                  Book now
                </button>
              </div>
            </div>
            <div
              className="route-card reveal in"
              data-from="Delhi"
              data-to="Agra"
            >
              <div className="route-top">
                <span className="route-path">Delhi → Agra</span>
                <span className="route-seats">9 cabs · today</span>
              </div>
              <div className="route-meta">
                <span>⏱ 3h 10m</span>
                <span>📏 233 km</span>
              </div>
              <div className="route-bottom">
                <span className="route-price">
                  ₹499 <small>/seat</small>
                </span>
                <button className="btn btn-primary btn-sm route-book">
                  Book now
                </button>
              </div>
            </div>
            <div
              className="route-card reveal in"
              data-from="Jaipur"
              data-to="Delhi"
            >
              <div className="route-top">
                <span className="route-path">Jaipur → Delhi</span>
                <span className="route-seats">6 cabs · today</span>
              </div>
              <div className="route-meta">
                <span>⏱ 4h 30m</span>
                <span>📏 280 km</span>
              </div>
              <div className="route-bottom">
                <span className="route-price">
                  ₹599 <small>/seat</small>
                </span>
                <button className="btn btn-primary btn-sm route-book">
                  Book now
                </button>
              </div>
            </div>
            <div
              className="route-card reveal in"
              data-from="Varanasi"
              data-to="Prayagraj"
            >
              <div className="route-top">
                <span className="route-path">Varanasi → Prayagraj</span>
                <span className="route-seats">5 cabs · today</span>
              </div>
              <div className="route-meta">
                <span>⏱ 2h 20m</span>
                <span>📏 125 km</span>
              </div>
              <div className="route-bottom">
                <span className="route-price">
                  ₹329 <small>/seat</small>
                </span>
                <button className="btn btn-primary btn-sm route-book">
                  Book now
                </button>
              </div>
            </div>
            <div
              className="route-card reveal in"
              data-from="Noida"
              data-to="Lucknow"
            >
              <div className="route-top">
                <span className="route-path">Noida → Lucknow</span>
                <span className="route-seats">3 cabs · today</span>
              </div>
              <div className="route-meta">
                <span>⏱ 6h 40m</span>
                <span>📏 480 km</span>
              </div>
              <div className="route-bottom">
                <span className="route-price">
                  ₹899 <small>/seat</small>
                </span>
                <button className="btn btn-primary btn-sm route-book">
                  Book now
                </button>
              </div>
            </div>
            <div
              className="route-card reveal in"
              data-from="Kanpur"
              data-to="Prayagraj"
            >
              <div className="route-top">
                <span className="route-path">Kanpur → Prayagraj</span>
                <span className="route-seats">7 cabs · today</span>
              </div>
              <div className="route-meta">
                <span>⏱ 3h 00m</span>
                <span>📏 200 km</span>
              </div>
              <div className="route-bottom">
                <span className="route-price">
                  ₹449 <small>/seat</small>
                </span>
                <button className="btn btn-primary btn-sm route-book">
                  Book now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
